import React, { useEffect } from "react";

import { Layout } from "antd";
import { useAuth, useMutation } from "../hooks";
import styles from "./app.module.css";
import Favicon from "react-favicon";

const { ["unauthenticated"]: unauthenticated } = styles as any;

// Components
import { AuthenticatedRoute, Header } from "../components";

// Pages
import {
  Login,
  Dashboard,
  Matters,
  MatterEditor,
  ConfigureNotifications,
  MatterTemplateEditor,
} from "../pages";

// Routes
import { Route, Routes, useLocation } from "react-router-dom";
import { Configuration } from "../pages/configuration";
import clsx from "clsx";
import { ErrorPage } from "../pages/error/error-page";
import { UserSettingsPage } from "../pages/user-settings/user-settings";
import { Helmet } from "react-helmet";
import { ParentMatterContainer } from "./parent-matter/parent-matter-container";
import { Userpilot } from "userpilot";
import { CreateProposalContainer } from "./create-proposal-container";

import { UPDATE_LAST_LOGIN_AT } from "~/graphql/mutation";
const { Content } = Layout;

const App: React.FC<{ ssrHost?: string }> = ({ ssrHost }) => {
  const { isAuthenticated, currentUser, logout } = useAuth(ssrHost);
  const location = useLocation();

  const [updateLastLogin] = useMutation(UPDATE_LAST_LOGIN_AT);
  useEffect(() => {
    if (isAuthenticated && currentUser?.id) {
      updateLastLogin();
    }
  }, [isAuthenticated, currentUser, updateLastLogin]);

  useEffect(() => {
    Userpilot.reload();
  }, [location]);

  useEffect(() => {
    Userpilot.initialize("NX-514837eb");
  }, []);

  return (
    <Layout className={clsx(!isAuthenticated && unauthenticated)}>
      <Helmet
        defaultTitle="VPD"
        titleTemplate="%s | VPD"
        link={[{ rel: "icon", type: "image/png", href: "favicon.ico" }]}
      />
      <Favicon url="https://assets.vpd.law/vpd-ui/vpd-favicon.ico"></Favicon>
      {isAuthenticated && <Header currentUser={currentUser} onClickLogout={logout} />}
      <Content>
        <Routes>
          <Route element={<AuthenticatedRoute element={<Dashboard />} />} path="/" />
          <Route element={<AuthenticatedRoute element={<Matters />} />} path="/matters" />
          <Route
            element={<AuthenticatedRoute element={<CreateProposalContainer />} />}
            path="/create"
          />
          <Route
            element={<AuthenticatedRoute element={<MatterEditor />} />}
            path="/matter-editor/:matterId/*"
          />
          <Route
            element={<AuthenticatedRoute element={<ParentMatterContainer />} />}
            path="/parent/:parentMatterId/*"
          />
          <Route
            element={<AuthenticatedRoute element={<MatterTemplateEditor />} />}
            path="/administrator/library-content/matter-templates/:matterId/*"
          />
          <Route
            element={<AuthenticatedRoute element={<Configuration />} />}
            path="/administrator/*"
          />
          <Route
            element={<AuthenticatedRoute element={<ConfigureNotifications />} />}
            path="/configure-notifications"
          />
          <Route
            element={<AuthenticatedRoute element={<UserSettingsPage />} />}
            path="/user-settings"
          />
          <Route path="/login" element={<Login ssrHost={ssrHost} />} />
          <Route element={<ErrorPage />} path="/error/:code" />
          <Route
            element={<AuthenticatedRoute element={<ErrorPage fromRoute={true} />} />}
            path="*"
          />
        </Routes>
      </Content>
    </Layout>
  );
};

export default App;
